<script setup lang="ts">
    defineProps<{
        label: string;
        detected: boolean;
        thresholdText: string;
    }>();
</script>

<template>
    <v-card
        class="detection-card"
        :class="{ detected }"
        variant="outlined"
        rounded="md"
        data-testid="hip-spine-detection"
    >
        <div class="content d-flex align-center justify-space-between ga-3">
            <div class="d-flex align-center ga-3">
                <v-icon
                    :icon="detected ? 'mdi-alert-circle' : 'mdi-information-outline'"
                    :color="detected ? 'warning' : 'info'"
                    size="20"
                />
                <span class="label">{{ label }}</span>
            </div>
            <div class="d-flex align-center ga-3">
                <span class="answer">{{ detected ? 'Yes' : 'No' }}</span>
                <span class="threshold">{{ thresholdText }}</span>
            </div>
        </div>
    </v-card>
</template>

<style scoped lang="scss">
    .detection-card {
        background: rgb(var(--v-theme-surface));
        border-color: rgb(var(--v-theme-grey-light-1));
        font-size: 14px;
    }

    .detection-card.detected {
        background: rgba(var(--v-theme-orange), 0.2);
        border-color: rgb(var(--v-theme-orange), 0.8);
    }

    .content {
        padding: 10px 12px;
    }

    .label {
        color: rgb(var(--v-theme-secondary-text));
    }

    .answer {
        font-weight: 700;
        color: rgb(var(--v-theme-secondary-text));
    }

    .threshold {
        color: rgb(var(--v-theme-secondary-text));
        white-space: nowrap;
    }
</style>
